import * as React from "react";
import { InstanceCreate } from "./InstanceCreate";
import { InstancePortal } from "./InstancePortal";
import { InstanceHome } from "./InstanceHome";
import { BreadcrumbGroup } from "@amzn/awsui-components-react";
import { SherpaHeader } from "../../components/layout/SherpaHeader";
import { UserProfilePortal } from "../user/UserProfilePortal";
import { SherpaFooter } from "../../components/layout/SherpaFooter";
import useRoutedParamsWithContext from "../../setup/useRoutedParamsWithContext";
import { getQueryParameterMap } from "../../utils/common-utils";

const InstanceHomeRoute = () => {
    const { instanceId } = useRoutedParamsWithContext();
    return <InstanceHome id={instanceId!} />;
};

const InstancePortalRoute = () => {
    const { instanceId } = useRoutedParamsWithContext();
    return <InstancePortal instanceId={instanceId!} />;
};

const InstanceHomePreviewRoute = () => {
    const { instanceId, previewId } = useRoutedParamsWithContext();
    return <InstanceHome id={instanceId!} backgroundImageBlobId={previewId} />;
};

const MyProfileRoute = () => {
    const { instanceId } = useRoutedParamsWithContext();
    const queryParamMap = getQueryParameterMap();
    const activeTabId = queryParamMap.get("tab") || "myFavorites";
    return <UserProfilePortal
        id={instanceId!}
        activeTabId={activeTabId}
    />;
};

export const instanceRoutes = [
    {
        path: "/instance/create",
        content: <InstanceCreate />,
        header: () => <SherpaHeader headerType="Home" />
    },
    {
        path: "/instance/:instanceId/admin",
        content: <InstancePortalRoute />,
        breadcrumbs: () => {
            const { instanceId } = useRoutedParamsWithContext();
            return <BreadcrumbGroup items={[
                { text: "Instance Admin Portal", href: `#/instance/${instanceId}/admin`}
            ]}/>;
        },
        header: () => {
            const { instanceId } = useRoutedParamsWithContext();
            return <SherpaHeader headerType="Other" instanceId={instanceId!} />;
        },
        footer: () => {
            const { instanceId } = useRoutedParamsWithContext();
            return <SherpaFooter variant="AdminPortal" entityId={instanceId!} />;
        }
    },
    {
        path: "/instance/:instanceId/home",
        content: <InstanceHomeRoute />,
        contentClass: "instance-home-no-padding",
        header: () => {
            const { instanceId } = useRoutedParamsWithContext();
            return <SherpaHeader headerType="InstanceHome" instanceId={instanceId!} />;
        },
        footer: () => {
            const { instanceId } = useRoutedParamsWithContext();
            return <SherpaFooter variant="InstanceHome" entityId={instanceId!} />;
        }
    },
    {
        path: "/instance/:instanceId/myProfile",
        breadcrumbs: () => {
            const { instanceId } = useRoutedParamsWithContext();
            return <BreadcrumbGroup items={[
                { text: "Instance Home", href: `#/instance/${instanceId}/home` },
                { text: "My Profile", href: `#/instance/${instanceId}/myProfile` }
            ]}/>;
        },
        content: <MyProfileRoute />,
        header: () => {
            const { instanceId } = useRoutedParamsWithContext();
            return <SherpaHeader headerType="Other" instanceId={instanceId!} />;
        },
        footer: () => {
            const { instanceId } = useRoutedParamsWithContext();
            return <SherpaFooter variant="AdminPortal" entityId={instanceId!} />;
        }
    },
    {
        path: "/instance/:instanceId/preview/:previewId/home",
        content: <InstanceHomePreviewRoute />,
        contentClass: "instance-home-no-padding",
        header: () => {
            const { instanceId } = useRoutedParamsWithContext();
            return <SherpaHeader headerType="InstanceHome" instanceId={instanceId!} />;
        },
        footer: () => {
            const { instanceId } = useRoutedParamsWithContext();
            return <SherpaFooter variant="InstanceHome" entityId={instanceId!} />;
        }
    }
];
